module.exports = __webpack_public_path__ + "static/media/university-accommodation.82f7d8b0.jpg";